/** The reader-facing Project name. A computer's slug is an identifier, never its display name. */
export function projectName(project) {
  return project.computer?.label ?? project.slug;
}

/** The one reading of a typed `/project <slug|id>` argument, shared by every surface that offers the
 *  command: the chat adapters' shared picker core (chatCommands.mjs) and the CLI. An EXACT project slug
 *  wins first, then a decimal id, so an all-digit slug is still a slug and a hand-typed name meets one rule
 *  everywhere. `projects` is the caller's own listing as the host returned it (`{ id, slug }` rows).
 *
 *  Returns the project id, or null when the argument names nothing. A decimal id is returned even when the
 *  listing does not carry it: whether the caller may enter that project is the host's answer on the
 *  switch, never this function's. */
export function resolveProjectArgument(projects, raw) {
  const arg = String(raw ?? '').trim();
  if (!arg) return null;
  const bySlug = projects.find((p) => String(p.slug) === arg);
  if (bySlug) return bySlug.id;
  return /^\d+$/.test(arg) ? Number(arg) : null;
}
